




























































































































import Vue from 'vue'
import { ExtranetServiceProxy } from '@/service-proxies/app-v2/extranet.service-proxies'
import { listColumns } from '../data'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {
  DeviceTypeServiceProxy,
  MachineServiceProxy
} from '@/service-proxies/app-v2/workStation.service-proxies'
import { MasterlinkUserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'
import {ConnectionRecordServiceProxy} from "@/service-proxies/app-v2/iot-extranet.service-proxies";
import moment from "moment";
import {AxiosRequestConfig, AxiosResponse} from "axios";
import axios from "@/utils/request";

const dsp = new DeviceTypeServiceProxy()
const csp = new CustomerServiceProxy()
const connectionRecordProxy = new  ConnectionRecordServiceProxy()
const msp = new MachineServiceProxy()
const musp = new MasterlinkUserServiceProxy()

export default Vue.extend({
  data() {
    return {
      listColumns,
      form: this.$form.createForm(this),
      customerList: [], // 客户列表
      typeList: [], // 类型列表
      machineList: [], // 机床列表
      userList: [], // 员工列表
      recordList: [],
      recordModalVisible: false,
      total: 0,
      pageSize: 20,
      current:1,
      loading: false,
      config: {
        rules: [{ type: 'object' }]
      }
    }
  },
  created() {
    this.getCustomer()
    this.getUser()
    this.getMachine()
    this.getType()
  },
  methods: {
    openRecordModal(){
      this.recordModalVisible = true
    },
    async getCustomer() {
      const data = await csp.getPageCustomer(undefined,1, '', -1)
      this.customerList = data.records
    },
    async getUser() {
      const data = await musp.page(1, '', '', -1)
      this.userList = data.data.records
    },
    async getMachine() {
      const value: any = {}
      const data = await msp.getMachineList(1, value, -1)
      this.machineList = data.records
    },
    async getType() {
      const value: any = {
        keyWord: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const data = await dsp.pageDeviceType(value)
      this.typeList = data.records
    },
    onSearch(){
      this.current=1
      this.getData()
    },
    reast() {
      this.current=1
      this.form.resetFields()
      this.getData()
    },
    onCancel(){
      this.current=1
      this.form.resetFields()
      this.recordList = []
      this.total = 0
    },
    visibleChange(value) {
      if (value) {
        this.form.resetFields()
        this.recordList = []
      }
    },
    exportData(){
      this.form.validateFields((err, values) => {
        if (!err) {

          const target = this.machineList.find((res) => res.id === values.deviceId)
          const value: any = {
            connectAccount: values.connectAccount,
            customerId: values.customerId,
            deviceCode: target ? target.serialNo : '',
            deviceId: values.deviceId,
            deviceTypeId: values.deviceType,
            deviceType: values.deviceType,
            end: values.end?moment(values.end).add(moment().utcOffset(),'minutes'): undefined,
            pageRequestDTO: {
              current: 1,
              size: -1
            },
            start: values.start? moment(values.start).add(moment().utcOffset(),'minutes'): undefined
          }
          this.download(value);
        }
      })

    },

    download(value){
      let url_ = "/iot-extranetv2/connection-record/export";
      url_ = url_.replace(/[?&]$/, "");

      const content_ = JSON.stringify(value);

      let options_ = <AxiosRequestConfig>{
        data: content_,
        method: "POST",
        url: url_,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: 'blob'
      };

      return axios.request(options_).then((_response: AxiosResponse) => {
        var a = document.createElement('a')
        a.download = `连接记录.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        var blob = new Blob([_response as any], {type: "application/vnd.ms-excel"})
        let url = URL.createObjectURL(blob)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      });
    },
    handleTableChange(current: number, pageSize: number) {
      this.pageSize=pageSize;
      this.current=current;
      this.getData();
    },
    getData() {
      this.form.validateFields((err, values) => {
        if (!err) {

          const target = this.machineList.find((res) => res.id === values.deviceId)
          const value: any = {
            connectAccount: values.connectAccount,
            customerId: values.customerId,
            deviceCode: target ? target.code : '',
            deviceId: values.deviceId,
            deviceTypeId: values.deviceType,
            deviceType: values.deviceType,
            end: values.end?moment(values.end).add(moment().utcOffset(),'minutes'): undefined,
            pageRequestDTO: {
              current: this.current,
              size: this.pageSize
            },
            start: values.start? moment(values.start).add(moment().utcOffset(),'minutes'): undefined
          }
          this.loading=true;
          connectionRecordProxy.getPage(value).then((res) => {
            this.recordList = res.items
            this.total=res.totalCount
          }).finally(()=>{
            this.loading=false;
          })
        }
      })
    }
  }
})
